import * as Sentry from '@sentry/react';
import { CircleXIcon } from 'lucide-react';
import { AlertDescription, AlertTitle, Alert } from '../components/shadcn/Alert';
import { ChildrenProp } from '../types/react-utility';

export function GlobalErrorBoundary({ children }: ChildrenProp) {
  return <Sentry.ErrorBoundary fallback={<FallbackComponent />}>{children}</Sentry.ErrorBoundary>;
}

function FallbackComponent() {
  return (
    <div className="flex h-screen items-center justify-center">
      <Alert variant="red">
        <CircleXIcon className="h-4 w-4" />
        <AlertTitle>An error has occurred</AlertTitle>
        <AlertDescription>Clear site data and reload the page</AlertDescription>
      </Alert>
    </div>
  );
}
